'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorInfoToError = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _buildError = require('conversations-infrastructure/errors/builders/buildError');

var errorInfoToError = exports.errorInfoToError = function errorInfoToError(message, channelId, errorInfo) {
  return (0, _buildError.buildError)(message, _extends({ channelId: channelId }, errorInfo));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/operators/errorInfoToError.js
// module id = 782
// module chunks = 2 3